export type ResearchResponsePhase = 'researching' | 'writing' | 'finalizing';

/** A missing provider phase cannot tell us that this is the final answer. */
export function isFinalAnswerText(metadata?: { openai?: { phase?: unknown } }): boolean {
  return metadata?.openai?.phase === 'final_answer';
}

export function parseResearchResponsePhase(value: unknown): ResearchResponsePhase | null {
  return value === 'researching' || value === 'writing' || value === 'finalizing' ? value : null;
}

export function getResearchResponsePhaseLabel(phase?: ResearchResponsePhase | null): string | null {
  if (phase === 'writing') return 'Writing the answer…';
  if (phase === 'finalizing') return 'Finalizing the answer…';
  return null;
}
